import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    email: '',
    phone: '',
    name: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [phoneError, setPhoneError] = useState('');  // State for phone number error
  const [isLoading, setIsLoading] = useState(false);  // State for loading indicator

  // Regex to validate phone number format (+923331234567)
  const phoneRegex = /^\+92\d{10}$/;


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Check phone number validity
    if (name === 'phone' && !phoneRegex.test(value)) {
      setPhoneError('Please enter a valid phone number in the format +923331234567');
    } else {
      setPhoneError('');  // Clear error if valid
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if phone number is valid before submission
    if (!phoneRegex.test(formData.phone)) {
      setPhoneError('Please enter a valid phone number in the format +923331234567');
      return;  // Prevent form submission
    }

    setIsLoading(true);

    try {
      // Send POST request to newsletter API
      const response = await fetch('https://gluco-planner.smartclinicpk.com/api/newsletter', {
        method: 'POST',
        headers: {
          'accept': '*/*',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          phoneNumber: formData.phone
        })
      });

      if (response.ok) {
        const responseData = await response.json();
        console.log('Form submitted successfully:', responseData);

        // Show success alert with API response message
        alert(`✅ ${responseData.message || 'Successfully subscribed to newsletter!'}`);

        setIsSubmitted(true);

        // Reset form after 3 seconds
        setTimeout(() => {
          setIsSubmitted(false);
          setFormData({ email: '', phone: '', name: '' });
          setPhoneError('');
        }, 3000);
      } else {
        // Handle API error
        const errorData = await response.json();
        console.error('API Error:', errorData);
        alert('Failed to subscribe. Please try again.');
      }
    } catch (error) {
      // Handle network error
      console.error('Network Error:', error);
      alert('Network error. Please check your connection and try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section id="contact" className="contact section">
      <div className="container">
        <div className="contact-content">
          <div className="contact-info">
            <h2 className="contact-title">Get Updates</h2>
            <p className="contact-subtitle">
              Stay informed about GlucoPlanner's latest features and updates.
              Join our community of healthcare professionals revolutionizing diabetes care.
            </p>
            <div className="contact-benefits">
              <div className="benefit-item">
                <span className="benefit-icon">📧</span>
                <span>Early access to new features</span>
              </div>
              <div className="benefit-item">
                <span className="benefit-icon">📱</span>
                <span>Product updates and announcements</span>
              </div>
            </div>
          </div>

          <div className="contact-form-container">
            {isSubmitted ? (
              <div className="success-message">
                <div className="success-icon">✅</div>
                <h3>Thank You!</h3>
                <p>We'll keep you updated on GlucoPlanner's progress.</p>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                <h3 className="form-title">For Timely Updates</h3>
                <div className="form-group">
                  <label htmlFor="name">Full Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    placeholder="Dr. John Smith"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    placeholder="doctor@hospital.com"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                    placeholder="+923331234567"
                  />
                  {phoneError && <div className="error-message" style={{ color: 'red' }}>{phoneError}</div>}
                </div>
                <button
                  type="submit"
                  className="btn btn-primary form-submit"
                  disabled={isLoading}
                >
                  {isLoading ? 'Subscribing...' : 'Subscribe'}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
